<template>
  <toBeTable :status="3" :routeQuery="$route.query" />
</template>

<script>
import toBeTable from "@//views/settlement-model/tobe-confirmed/index";
export default {
  name: "Draft",
  components: {
    toBeTable,
  }};
</script>

<style scoped>
</style>
